<template>
  <div>
    <!-- <v-badge
      color="red"
      offset-x="15"
      offset-y="20"
      icon="mdi-bell-alert"
      content="1"
    > -->
    <v-menu
      v-model="isMenuOpen"
      close-on-click
      bottom
      offset-y
      min-width="100%"
      :nudge-bottom="20"
      eager
    >
      <template #activator="{ on }">
        <div>
          <v-badge
            v-if="$root.workspaceFeatures.shipmentsDemo && notificationCount > 0"
            color="error"
            :offset-x="$vuetify.breakpoint.smAndDown ? -20 : -30"
            :offset-y="$vuetify.breakpoint.smAndDown ? -20 : -28"
            icon="mdi-bell-alert"
            :content="notificationCount"
          />
          <img
            :src="menuIcon"
            :height="imageHeight"
            alt="Menu icon"
            v-on="on"
          >
        </div>
      </template>
      <v-list light>
        <template v-if="hasMultipleTeams">
          <v-list-item
            :to="hasSelectedTeam ? teamsListRoute : undefined"
            exact
            @click="isMenuOpen = false"
          >
            <v-list-item-action>
              <v-icon>mdi-group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Switch Workspace</v-list-item-title>
              <v-list-item-subtitle v-if="selectedTeamName">
                {{ selectedTeamName }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action style="min-width: auto;">
              <v-icon style="font-size: 20px; color: #bdbdbd;">
                mdi-chevron-right
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-divider class="mb-1 mt-1" />
        </template>
        <v-list-item
          v-if="$root.workspaceFeatures.shipmentsDemo"
          :to="notificationsRoute"
          exact
          @click="isMenuOpen = false"
        >
          <v-list-item-action>
            <v-badge
              v-if="notificationCount > 0"
              color="error"
              :offset-x="8"
              :offset-y="8"
              icon="mdi-bell-alert"
              :content="notificationCount"
            >
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Notifications</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="includeTemperatureDataDownload"
          :to="temperatureDataDownloadRoute"
          exact
          :disabled="!hasSelectedTeam"
          @click="isMenuOpen = false"
        >
          <v-list-item-action>
            <v-icon>mdi-thermometer</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Temperature Data Download</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="hasSelectedTeam ? facilitiesRoute : undefined"
          exact
          :disabled="!hasSelectedTeam"
          @click="isMenuOpen = false"
        >
          <v-list-item-action>
            <v-icon>mdi-warehouse</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Facilities</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :to="hasSelectedTeam ? dashbaordsRoute : undefined"
          exact
          :disabled="!hasSelectedTeam || !hasDashboards"
          @click="isMenuOpen = false"
        >
          <v-list-item-action>
            <v-icon>mdi-chart-bar</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Dashboards</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="isSettingsEnabled"
          :to="settingsRoute"
          exact
          @click="isMenuOpen = false"
        >
          <v-list-item-action>
            <v-icon>mdi-settings</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <LogOut />
        </v-list-item>
      </v-list>
    </v-menu>
    <!-- </v-badge> -->
  </div>
</template>
<script>
import MenuIcon from '../../../assets/icons/menu-icon.svg';
import { routeNames } from '../../../constants';
import { shipments } from '../../../data/shipments-demo';
import LogOut from '../auth/log-out';

export default {
  name: 'Menu',
  components: {
    LogOut,
  },
  data() {
    return {
      isMenuOpen: false,
    };
  },
  computed: {
    selectedTeam() {
      return this.$store.state.teams.selectedTeam;
    },
    hasSelectedTeam() {
      return this.$store.getters['teams/hasSelectedTeam'];
    },
    hasDashboards() {
      return this.$store.getters['dashboards/hasDashboards'];
    },
    menuIcon() {
      return MenuIcon;
    },
    imageHeight() {
      return this.$vuetify.breakpoint.smAndDown ? 35 : 45;
    },
    dashbaordsRoute() {
      return { name: routeNames.dashboards.index };
    },
    notificationsRoute() { return { name: routeNames.notifications.list }; },
    facilitiesRoute() {
      return { name: routeNames.facilities.index };
    },
    isSettingsEnabled() {
      return this.$root.featureToggles.includeSettingsScreen();
    },
    settingsRoute() {
      return { name: routeNames.settings };
    },
    notificationCount() {
      return shipments.map((s) => s.alerts || []).flatMap((a) => a).length;
    },
    includeTemperatureDataDownload() {
      return this.$root.workspaceFeatures.multiLabelTemperatureDownload
        && this.$store.getters.isMobileApp;
    },
    temperatureDataDownloadRoute() { return { name: routeNames.temperature.download }; },
    teamsListRoute() {
      return {
        name: routeNames.workspace.list,
        query: { returnTo: routeNames.teamHome },
      };
    },
    selectedTeamName() {
      return this.$store.state.teams.selectedTeam?.name || '';
    },
    hasMultipleTeams() {
      return this.$store.state.teams.teams.length > 1;
    },
  },
  watch: {
    selectedTeam() {
      // So that we get dashboards for new team, when team is switched
      this.conditionallyGetDashboards();
    },
    isMenuOpen() {
      if (this.isMenuOpen) {
        // this is in the case where we've not yet got dashbaords
        this.conditionallyGetDashboards();
      }
    },
  },
  created() {
    this.conditionallyGetDashboards();
  },
  methods: {
    conditionallyGetDashboards() {
      if (this.$store.getters['teams/hasSelectedTeam'] && !this.hasDashboards) {
        this.getDashboards();
      }
    },
    getDashboards() {
      this.$store.dispatch('dashboards/getDashboards');
    },

  },
};
</script>
